/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type sagaWatchersProviderQueryVariables = {
    id: string;
};
export type sagaWatchersProviderQueryResponse = {
    readonly providerById: {
        readonly _id: string;
        readonly name: string | null;
        readonly oid_avatar: string | null;
        readonly setting: {
            readonly settings: {
                readonly reminder: {
                    readonly enabled: boolean | null;
                } | null;
                readonly cancellation: {
                    readonly enabled: boolean | null;
                } | null;
                readonly telehealth: {
                    readonly enabled: boolean | null;
                } | null;
                readonly followup: {
                    readonly enabled: boolean | null;
                } | null;
                readonly feedback: {
                    readonly enabled: boolean | null;
                } | null;
                readonly referral: {
                    readonly enabled: boolean | null;
                } | null;
                readonly scheduler: {
                    readonly enabled: boolean | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type sagaWatchersProviderQuery = {
    readonly response: sagaWatchersProviderQueryResponse;
    readonly variables: sagaWatchersProviderQueryVariables;
};



/*
query sagaWatchersProviderQuery(
  $id: MongoID!
) {
  providerById(_id: $id) {
    _id
    name
    oid_avatar
    setting {
      settings {
        reminder {
          enabled
        }
        cancellation {
          enabled
        }
        telehealth {
          enabled
        }
        followup {
          enabled
        }
        feedback {
          enabled
        }
        referral {
          enabled
        }
        scheduler {
          enabled
        }
      }
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "_id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_avatar",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabled",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "SettingSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingSettingsReminder",
      "kind": "LinkedField",
      "name": "reminder",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingSettingsCancellation",
      "kind": "LinkedField",
      "name": "cancellation",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingSettingsTelehealth",
      "kind": "LinkedField",
      "name": "telehealth",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingSettingsFollowup",
      "kind": "LinkedField",
      "name": "followup",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingSettingsFeedback",
      "kind": "LinkedField",
      "name": "feedback",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingSettingsReferral",
      "kind": "LinkedField",
      "name": "referral",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingSettingsScheduler",
      "kind": "LinkedField",
      "name": "scheduler",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sagaWatchersProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Provider",
        "kind": "LinkedField",
        "name": "providerById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Setting",
            "kind": "LinkedField",
            "name": "setting",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sagaWatchersProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Provider",
        "kind": "LinkedField",
        "name": "providerById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Setting",
            "kind": "LinkedField",
            "name": "setting",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "95fd08c4cb710a912f59e7f40715136f",
    "id": null,
    "metadata": {},
    "name": "sagaWatchersProviderQuery",
    "operationKind": "query",
    "text": "query sagaWatchersProviderQuery(\n  $id: MongoID!\n) {\n  providerById(_id: $id) {\n    _id\n    name\n    oid_avatar\n    setting {\n      settings {\n        reminder {\n          enabled\n        }\n        cancellation {\n          enabled\n        }\n        telehealth {\n          enabled\n        }\n        followup {\n          enabled\n        }\n        feedback {\n          enabled\n        }\n        referral {\n          enabled\n        }\n        scheduler {\n          enabled\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '9acccc01d5fb03b1390549dd17c29e74';
export default node;
